import { storeItem } from 'helpers/store';
import { setCookie } from 'nookies';

import { identify as analyticsIdentify, trackEvent } from '../helpers/analytics';
import { identifyUser } from '../helpers/supportChat';
import { getDomainName } from '../helpers/urlHelpers';

export const mapOAuthProviderName = (provider) => {
  switch (provider) {
    case 'google_oauth2':
      return 'Google';
    case 'linkedin':
      return 'LinkedIn';
    default:
      return provider;
  }
};

export const setupUserSession = (token, user) => {
  storeItem('authToken', token);
  setCookie(null, 'authToken', token, {
    path: '/',
    domain: getDomainName(),
    maxAge: 365 * 24 * 60 * 60,
    secure: true,
  });

  analyticsIdentify(user);
  identifyUser(user);
  trackEvent('user_logged_in');

  return user;
};
